import { config, appFetch } from "../appFetch";

export const getHomeSlider = (onSuccess) => appFetch(`https://api.galicine.com.es/api/slider/function::getAll`, config("GET"), onSuccess);
export const getHomeSliderById = (id, onSuccess) => appFetch(`https://api.galicine.com.es/api/slider/getById::${id}`, config("GET"), onSuccess);
